import jwt_decode from 'jwt-decode'
import { createSocketUser } from "../config/socketConnectivity";

export const decodeJwt = (token) => {
  if (token) {
    token = token.replace('Bearer ', '')
    const decoded = jwt_decode(token)
    createSocketUser(decoded._id);
    return decoded
  }
}
